import styled from "styled-components";

export const ContactStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media only screen and (max-width: 560px) {
    padding: 20px;
  }
`;

export const ContactContainer = styled.div`
  flex: 0.5;
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  padding: 20px;
  width: 100%;

  @media only screen and (max-width: 560px) {
    flex-direction: column;
    justify-content: center;
  }
`;
export const ContactDetails = styled.div`
  flex: 0.5;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export const Detail = styled.div`
  display: flex;
`;
export const DetailContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 10px;
  margin-bottom: 10px;
  gap: 10px;

  svg {
    font-size: 18px;
  }
`;

export const Form = styled.div`
  flex: 0.5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  max-width: 500px;
  padding: 40px 40px 60px;
  background: var(--background-color-main);
  border-radius: 10px;
  box-shadow: -5px -5px 10px rgba(255, 255, 255, 0.05),
    5px 5px 15px rgba(0, 0, 0, 0.5);
  width: 100%;

  @media only screen and (max-width: 560px) {
    margin-bottom: 30px;
  }
`;

export const FormContainer = styled.div`
  position: relative;
  margin-top: 40px;
  width: 100%;
`;
export const InputContainer = styled.div`
  input[type="submit"] {
    margin-top: 20px;
    box-shadow: -2px -2px 6px rgba(255, 255, 255, 0.1),
      2px 2px 6px rgba(0, 0, 0, 0.8);
  }
  input[type="submit"]:active {
    color: #006c9c;
    margin-top: 20px;
    box-shadow: inset -2px -2px 6px rgba(255, 255, 255, 0.1),
      inset 2px 2px 6px rgba(0, 0, 0, 0.8);
  }

  input::placeholder {
    color: #555;
    font-size: 18px;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 50px;
  background: var(--background-color-main);
  outline: none;
  border: none;
  border-radius: 10px;
  padding: 5px 15px;
  color: var(--text-primary-color);
  font-size: 18px;
  box-shadow: inset -2px -2px 6px rgba(255, 255, 255, 0.1),
    inset 2px 2px 6px rgba(0, 0, 0, 0.8);
  margin-bottom: 15px;
`;
export const TextArea = styled.textarea`
  width: 100%;
  max-width: 100%;
  height: 50px;
  background: var(--background-color-main);
  outline: none;
  border: none;
  border-radius: 10px;
  padding: 5px 15px;
  color: var(--text-primary-color);
  font-size: 18px;
  box-shadow: inset -2px -2px 6px rgba(255, 255, 255, 0.1),
    inset 2px 2px 6px rgba(0, 0, 0, 0.8);
  resize: no-resize;

  & ::placeholder {
    color: #555;
    font-size: 18px;
  }
`;

export const Status = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
`;
